import styled from "styled-components";

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const FormColumn = styled.div`
	flex: 1;
`;

export const FormRow = styled.div`
	display: flex;
	gap: 12px;
`;

export const StatusSection = styled.div`
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid ${(props) => props.theme.colours.light_1};
	
	h4 {
		margin: 0 0 8px 0;
		color: ${(props) => props.theme.colours.primary};
		font-size: 16px;
		font-weight: 600;
	}
	
	p {
		margin: 0 0 16px 0;
		color: ${(props) => props.theme.colours.text_1};
		font-size: 14px;
	}
	
	> div {
		margin-bottom: 12px;
	}
`;

export const Container = styled.div`
	background-color: ${(props) => props.theme.colours.light_0};
	padding: 24px;
	table {
		border-collapse: collapse;
		width: 100%;
		small {
			color: ${(props) => props.theme.colours.danger};
		}
	}
	th {
		background-color: ${(props) => props.theme.colours.primaryLight};
		color: ${(props) => props.theme.colours.primary};
		text-transform: uppercase;
		margin: 6px;
		padding: 12px;
	}
	tr {
		height: 36px;
		padding-left: 12px;
	}
	td {
		margin: 6px;
		padding: 6px;
		min-width: 60px;
		vertical-align: middle;
	}

	/* Column widths: 1) URL (wide), 2) Type (narrow), 3) Failures, 4) Toggle, 5) Actions (fixed) */
	td:nth-child(1) {
		width: 55%;
	}
	td:nth-child(2) {
		width: 15%;
		white-space: nowrap;
	}
	td:nth-child(3) {
		width: 10%;
	}
	td:nth-child(4) {
		width: 10%;
	}
	td:nth-child(5) {
		width: 10%;
		text-align: right;
		white-space: nowrap;
	}
`;
